import { useEffect } from 'react';

export function useEffectOnEveryRender(effect) {
  useEffect(() => {
    effect();
  });
}

/**
 * Use effect on first render.
 * 
 * @param {function} effect 
 */
export function useEffectOnFirstRender(effect) {
  useEffect(() => {
    effect();
  }, []);
}

export function useEffectOnFirstAndUpdateRender(effect, inputs) {
  useEffect(() => {
    effect();
  }, inputs);
}
